import React, { useEffect, useRef, useState } from 'react';
import BusinessListModal from './BusinessListModal';
import GreetingsModal from './GreetingsModal';
import AdModal from './AdModal';

const VillageMunch = ({ gaonSrNo }) => {
  const [paidContent, setPaidContent] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const LIMIT = 10;
  const bottomRef = useRef(null);

  const fetchContent = (newOffset = 0, append = false) => {
    fetch(`https://mazagaon.co.in/api/get_paid_content.php?gaonSrNo=${gaonSrNo}&limit=${LIMIT}&offset=${newOffset}`)
      .then(res => res.json())
      .then(data => {
        if (data.length < LIMIT) setHasMore(false);

        if (append) {
          setPaidContent(prev => [...prev, ...data]);
        } else {
          setPaidContent(data);
        }

        setOffset(newOffset + LIMIT);
        setTimeout(() => {
          bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      })
      .catch(err => {
        console.error("❌ Error fetching paid content:", err);
        setError('डेटा मिळवण्यात अडचण आली');
      });
  };

  useEffect(() => {
    setOffset(0);
    setHasMore(true);
    setPaidContent([]);
    fetchContent(0);
  }, [gaonSrNo]);

  const handleAddBusiness = (data) => {
    console.log('New Business:', data);
    setShowBusinessListModal(false);
  };

  const handleAddMessage = (newMessage) => {
    setPaidContent(prev => [newMessage, ...prev]);
    setShowGreetingsModal(false);
  };
  
  const handleAddAd = (data) => {
    console.log('New Ad:', data);
    setShowAdModal(false);
  };

  const [showBusinessListModal, setShowBusinessListModal] = useState(false);
  const [showGreetingsModal, setShowGreetingsModal] = useState(false);
  const [showAdModal, setShowAdModal] = useState(false);

  if (error) return <div className="panel error">{error}</div>;

  const handleWhatsAppShare = (item) => {
    // Map item.type to Marathi labels
    const typeLabel = {
      'Birthday': 'वाढदिवसाच्या शुभेच्छा',
      'Greetings': 'शुभेच्छा',
      'Tribute': 'मानवंदना'
    }[item.type] || item.type; // Fallback to item.type if not found
  
    const imageUrl = item.image ? encodeURI(item.image) : '';
    const weburl = `www.mazagaon.co.in`;
    
    const msgText = `*${item.type}*\n\n${
      item.title
    } यांस ${typeLabel}\n\n${
      item.description
    }\n\n${
      imageUrl ? '📸 ' + imageUrl + '\n\n' : ''
    }`;
    
    const encodedText = encodeURIComponent(msgText);
    const whatsappUrl = `https://wa.me/?text=${encodedText}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="container my-3 pb-5">
      <h3 className="text-center mb-4">🎉 गाव मंच</h3>

      {/* Paid Cards */}
      {[...paidContent].reverse().map((item, idx) => (
        <div className="card shadow mb-3" key={idx}>
          {item.image && <img src={item.image} className="card-img-top" alt={item.title} />}
          <div className="card-body">
            <h5 className="card-title">
              {item.title}
              </h5>
              <p>
              {' यांस: '}
              <span className="badge bg-warning text-dark">
                {item.type === 'Birthday' && 'वाढदिवसाच्या शुभेच्छा'}
                {item.type === 'Greetings' && 'शुभेच्छा'}
                {item.type === 'Tribute' && 'मानवंदना'}
                </span>
              <span className="badge text-dark badgesymbol">
                {item.type === 'Birthday' && '🎂'}
                {item.type === 'Greetings' && '👏🏼'}
                {item.type === 'Tribute' && '🙏🏼'}
                {!['Birthday', 'Greetings', 'Tribute'].includes(item.type) && item.type}
              </span>
              </p>
            <p className="card-text">{item.description}</p>
            {item.contact && (
              <a href={`tel:${item.contact}`} className="btn btn-sm btn-outline-primary">📞 Call Now</a>
            )}
            <span style={{textalign:'left'}}>
                {item.type === 'Birthday' && 'शुभेच्छुक'}
                {item.type === 'Greetings' && 'शुभेच्छुक'}
                {item.type === 'Tribute' && 'शोकाकुल'}
                 : {item.messanger_name}</span>
            <p className='msgdatetime my-0'>
                    {new Date(item.date).toLocaleString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    })}
            </p>
            <div
                    className='sharemessage'
                    style={{ cursor: 'pointer', fontSize: '1.5rem' }}
                    onClick={() => handleWhatsAppShare(item)}
                    title="व्हॉट्सअ‍ॅप वर शेअर करा"
                  >
                    ⤴️
                  </div>

          </div>
        </div>
      ))}

      {/* Load More */}
      {hasMore && (
        <div className="text-center my-3">
          <button className="btn btn-outline-primary" onClick={() => fetchContent(offset, true)}>
            आणखी दाखवा ⬇️
          </button>
        </div>
      )}

      <div ref={bottomRef} />

      {/* Sticky Bottom Action Bar */}
      <div className="VMBottomActionBar bg-light border-top d-flex justify-content-around py-0 shadow-sm">
        <button className="btn btn-outline-dark" onClick={() => setShowBusinessListModal(true)}>🏪 व्यवसाय सूची</button>
        <button className="btn btn-outline-dark" onClick={() => setShowGreetingsModal(true)}>➕ 💬संदेश</button>
        <button className="btn btn-outline-dark" onClick={() => setShowAdModal(true)}>➕ 📢जाहिरात</button>
      </div>

      {/* Modals */}
      {showBusinessListModal && (
        <BusinessListModal show={true} onClose={() => setShowBusinessListModal(false)} onSubmit={handleAddBusiness} gaonSrNo={gaonSrNo} />
      )}
      {showGreetingsModal && (
        <GreetingsModal show={true} onClose={() => setShowGreetingsModal(false)} onSubmit={handleAddMessage} gaonSrNo={gaonSrNo} />
      )}
      {showAdModal && (
        <AdModal show={true} onClose={() => setShowAdModal(false)} onSubmit={handleAddAd} gaonSrNo={gaonSrNo} />
      )}
    </div>
  );
};

export default VillageMunch;
